import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { EnjoyingAppDialogComponent } from '@app-modules/feature/my-referral/enjoying-app-dialog/enjoying-app-dialog.component';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { ClassSessionService } from 'src/app/core/services/class-session.service';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.css']
})
export class FeedbackDialogComponent implements OnInit {

  public firstQuestionAnsKey: string = '';

  public secondQuestionAnsKey: string = '';

  public isOpenFinalQuestion: boolean = false;

  public isSkipDisabled: boolean = false;

  public isSubmitDisabled: boolean = true;

  public feedBackTitle: string = "Thank you! Can you help us with your feedback?"

  public feedbackQuestions: any = [
    {
      "title": "1. Please rate overall experience?",
      "options": [
        {
          "label": "Poor",
          "key": "poor",
          "selected": false
        },
        {
          "label": "Fair",
          "key": "fair",
          "selected": false
        },
        {
          "label": "Good",
          "key": "good",
          "selected": false
        },
        {
          "label": "Excellent",
          "key": "excellent",
          "selected": false
        }
      ]
    },
    {
      "title": "2. Did the tutor help you understand the topic of the class?",
      "options": [
        {
          "label": "Strongly Agree",
          "key": "stronglyAgree",
          "selected": false
        },
        {
          "label": "Agree",
          "key": "agree",
          "selected": false
        },
        {
          "label": "Disagree",
          "key": "disagree",
          "selected": false
        },
        {
          "label": "Strongly Disagree",
          "key": "stronglyDisAgree",
          "selected": false
        }
      ]
    },
    {
      "title": "3. Check all the options you faced difficulty with during the class.",
      "options": [
        {
          "label": "Tutor’s Audio",
          "key": "tutorAudio",
          "selected": false
        },
        {
          "label": "Tutor’s Video",
          "key": "tutorVideo",
          "selected": false
        },
        {
          "label": "Issues with chat",
          "key": "chat",
          "selected": false
        },
        {
          "label": "Issues with content shared during class",
          "key": "content",
          "selected": false
        },
        {
          "label": "Inability to get doubts cleared",
          "key": "doubts",
          "selected": false
        },
        {
          "label": "Pace of the class",
          "key": "pace",
          "selected": false
        }
      ]
    }
  ]
  experienceFeedback:number;
  userPositiveLoginDetailsId:any;
  constructor(
    private dialogRef: MatDialogRef<FeedbackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sessionService: ClassSessionService,
    private _inviteNdEarn:InviteEarnService,
    public dialog: MatDialog,private _router:Router,
  ) { }

  ngOnInit(): void {
    console.log("Feedback: ", this.data)
  }

  updateFormValue = (_index: number, _key: any) => {
    let _reqObj = this.feedbackQuestions[_index];
    if(_index < 2) {
      _reqObj.options.map((item: any) => {item.key == _key ? item.selected = true : item.selected = false});
      if(_index == 0) {
        this.firstQuestionAnsKey = _key;
        this.experienceFeedback=_key;
        if(this.firstQuestionAnsKey=='excellent'){
          this.experienceFeedback=5;
        }else{
          this.experienceFeedback=0;
        }
        console.log({liveClass:this.experienceFeedback});
      } else {
        this.secondQuestionAnsKey = _key;
      }

      if(['poor', 'fair'].includes(this.firstQuestionAnsKey) || ['disagree', 'stronglyDisAgree'].includes(this.secondQuestionAnsKey)) {
        this.isOpenFinalQuestion = true;
      } else {
        this.isOpenFinalQuestion = false;
        this.feedbackQuestions[2].options.forEach(item => {
          item.selected=false
        });
      }
    } else {
      _reqObj.options.map((item: any) => {item.key == _key ? item.selected = !item.selected : item.selected = item.selected});
    }

    this.checkSubmitStillDisabled();
  }

  sendFeedbackData(){
    let currentLogin=JSON.parse(localStorage.getItem('loginCount'));
    let userId=JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    let prodctId=2;
  
    this._inviteNdEarn.sendFeedbackData(currentLogin,prodctId,this.experienceFeedback,userId.userId).subscribe({next:(e)=>{
      this.userPositiveLoginDetailsId=e['userPositiveLoginDetailsId'];
      if(e['positiveLoginCount']==5||e['remindMeLaterCount']==1){
        this.enjoyAppInvite();
      }
    },error:(err)=>{console.error(err);
    }});
    
  }

   //Dialog for enjoying app
   enjoyAppInvite() {
    const config: MatDialogConfig = {
      panelClass: ['REF-enjoyapp-dialog', 'UNFAPP-mweb-btmstiky-modal'],
      width:'250',           
      data: { },
    };
    const dialogRef = this.dialog.open(EnjoyingAppDialogComponent, config);

    dialogRef.afterClosed().subscribe((value) => {
      console.log(value);
      if(value?.data){
        console.log('Shared!');
        this._router.navigateByUrl('/dashboard/referral/')
      }else{
        console.log('not shared!');
        //? calling reminder api
        this._inviteNdEarn.remindMeLaterPopup(this.userPositiveLoginDetailsId);
      }
    });
  }

  checkSubmitStillDisabled = () => {
    let _firstQuesSelectionLen = this.feedbackQuestions[0].options.filter((x:any)=>x.selected==true).length;
    let _secQuesSelectionLen = this.feedbackQuestions[1].options.filter((x:any)=>x.selected==true).length;
    let _thiredQuesSelectionLen = this.feedbackQuestions[2].options.filter((x:any)=>x.selected==true).length;

    if(_firstQuesSelectionLen > 0 || _secQuesSelectionLen > 0 || _thiredQuesSelectionLen > 0){
      this.isSubmitDisabled = false;
    } else {
      this.isSubmitDisabled = true;
    }
  }

  skipFeedbackForm = () => {
    this.dialogRef.close({event: 'skip'});
  }


  submitFeedbackForm = () => {
    this.isSkipDisabled = true;
    // console.log(this.);
    if(this.experienceFeedback){
      this.sendFeedbackData();
    }

    let _formValues: any = {
      title: this.feedBackTitle,
      questions: this.feedbackQuestions,
      class: this.data.eclassInfo.id,
      student: {
        id: this.data.crntUserInfo.userId,
        firstName: this.data.crntUserInfo.firstName,
        lastName: this.data.crntUserInfo.lastName,
      },
      tenant: 123,
      status: 'active'
    }

    this.sessionService.submitSessionFeedback(_formValues).subscribe(
      (res: any) => {
        console.log("Feedback Success Response: ", res)
        this.isSkipDisabled = false;
        this.dialogRef?.close({event: 'feedback-submitted',_formValues:_formValues})
      },
      (err: any) => {
        this.isSkipDisabled = false;
        console.log("Feedback Error Response: ", err)
      }
    )
  }

}
